import React, { useState, useEffect } from 'react';
import { Link } from "gatsby"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXTwitter } from '@fortawesome/free-brands-svg-icons'

import {
  //Menu,
  Button,
} from 'semantic-ui-react';

export default function ContentButton(props) {
  //console.log('ContentButton - props', props);

  const {
    variationType,
    textColor,
    link,
    icon,
    linkText,
    commonContentLink,
  } = props;

  const { 
    linkContentText,
    dOMID, 
    externalLink, 
    internalLink, 
    mediaPDF 
  } = commonContentLink;

  //const textColor = textColor ? textColor : props.header_text_color ? props.header_text_color : null;

  const isExternalLink = (link.url && link.url.includes('https')) || (link.url && link.url.includes('http'));
  //console.debug('ContentButton - isExternalLink', isExternalLink);

  const [buttonConfigState, setButtonConfigState] = useState({
    init: false,
    as: null,
    to: null,
    href: null,
    target: null,
    rel: null,
    content: null,
    icon: null,
    labelPosition: null,
  });

  useEffect(() => {
    if (buttonConfigState.init === false) {
      let buttonConfig = {
        as: null,
        to: null,
        href: null,
        target: null,
        rel: null,
        content: null,
        icon: null,
        labelPosition: null,
      }
      //process button content
      if (link && link.text) {
        buttonConfig.content = link.text
      } else if (linkText) {
        buttonConfig.content = linkText
      } else if (linkContentText) {
        buttonConfig.content = linkContentText
      }
      //process button icon
      if (icon) {
        if (icon.iconName !== null) {
          buttonConfig.icon = icon.iconName
        }
        if (icon.iconLabelPosition !== null) {
          buttonConfig.labelPosition = icon.iconLabelPosition
        }
      }
      //process button type
      if (link && link.url !== null) {
        if (isExternalLink) {
          buttonConfig.as = 'a'
          buttonConfig.href = link.url
          buttonConfig.target = '_blank'
          buttonConfig.rel = 'noreferrer'
        } else {
          buttonConfig.as = Link
          buttonConfig.to = link.url
        }
      } else if (dOMID) {
        //mailto addresses or DOM ID for inner page scroll to section
        buttonConfig.as = 'a'
        buttonConfig.href = dOMID
      } else if (internalLink && internalLink.url) {
        buttonConfig.as = Link
        buttonConfig.to = internalLink.url
      } else if (externalLink && externalLink.url) {
        buttonConfig.as = 'a'
        buttonConfig.href = externalLink.url
        buttonConfig.target = '_blank'
        buttonConfig.rel = 'noreferrer'
      } else if (mediaPDF && mediaPDF.gatsbyLocalFile && mediaPDF.gatsbyLocalFile.publicURL) {
        buttonConfig.as = 'a'
        buttonConfig.href = mediaPDF.gatsbyLocalFile.publicURL
        buttonConfig.target = '_blank'
        buttonConfig.rel = 'noreferrer'
      }
      buttonConfig.init = true;
      setButtonConfigState(buttonConfig);
    }
  }, [buttonConfigState, dOMID, externalLink, icon, internalLink, isExternalLink, link, linkContentText, linkText, mediaPDF]);
  //console.debug('buttonConfigState - '+ props.displayText, {props, buttonConfigState});
  
  return (
    <>
      {/* <style dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize([
          '#layout-wrapper a.ui.button.postUpSignUpButton {',
          '  color: '+ textColor +';',
          '  box-shadow: inset 0 0 0 2px '+ textColor +' !important;',
          '}',
          '#layout-wrapper a.ui.button.postUpSignUpButton:hover {',
          '  color: '+ props.header_background_color +' !important;',
          '  background: '+ textColor +' !important;',
          '}'
          ].join('\n'))
        }}>
      </style> */}
      {(() => {
        switch(variationType) {
          case 'primary':
            return (
              <Button primary className={'site-content-button'}
                style={{ color: textColor !== null ? textColor : null, }}
                as={buttonConfigState.as}
                to={buttonConfigState.to}
                href={buttonConfigState.href}
                target={buttonConfigState.target}
                rel={buttonConfigState.rel}
                // as={link && link.url !== null ? (isExternalLink ? 'a' : Link) : null}
                // to={link && link.url !== null ? (isExternalLink ? null : link.url) : null}
                // href={isExternalLink ? link.url : null}
                // target={isExternalLink ? '_blank' : null}
                // rel={link && link.url ? 'noreferrer' : null}
                icon={buttonConfigState.icon}
                labelPosition={buttonConfigState.labelPosition}
                content={buttonConfigState.content}
              />
            );
          case 'outline':
            return (
              <Button className={'site-content-button outline'}
                style={{ color: (textColor !== null ? textColor : null), borderColor: (textColor !== null ? textColor : null) }}
                as={buttonConfigState.as}
                to={buttonConfigState.to}
                href={buttonConfigState.href}
                target={buttonConfigState.target}
                rel={buttonConfigState.rel}
                icon={buttonConfigState.icon}
                labelPosition={buttonConfigState.labelPosition}
                content={buttonConfigState.content}
                // as={link && link.url !== null ? (isExternalLink ? 'a' : Link) : null}
                // to={link && link.url !== null ? (isExternalLink ? null : link.url) : null}
                // href={isExternalLink ? link.url : null}
                // target={isExternalLink ? '_blank' : null}
                // rel={link && link.url ? 'noreferrer' : null}
                // icon={icon && icon.iconName !== null ? icon.iconName : null}
                // labelPosition={icon && icon.iconLabelPosition !== null ? icon.iconLabelPosition : null}
                // content={linkText || (link && link.text)}
              />
            );
          case 'simple':
            return (
              <>
                {icon && icon.iconName === 'twitter' ?
                  <Button basic className={'site-content-button simple'}
                    style={{ color: textColor ? textColor : null, }}
                    as={buttonConfigState.as}
                    to={buttonConfigState.to}
                    href={buttonConfigState.href}
                    target={buttonConfigState.target}
                    rel={buttonConfigState.rel}
                    //icon={buttonConfigState.icon}
                    labelPosition={buttonConfigState.labelPosition}
                    content={buttonConfigState.content}
                    // as={link && link.url !== null ? (isExternalLink || dOMID ? 'a' : Link) : null}
                    // to={link && link.url !== null ? (isExternalLink || dOMID ? null : link.url) : null}
                    // href={dOMID ? dOMID : isExternalLink ? link.url : null}
                    // target={isExternalLink || dOMID ? '_blank' : null}
                    // rel={link && link.url ? 'noreferrer' : null}
                    //icon={icon && icon.iconName !== null ? icon.iconName : null}
                    // labelPosition={icon && icon.iconLabelPosition !== null ? icon.iconLabelPosition : null}
                    // content={linkText || (link && link.text)}
                  >
                    <FontAwesomeIcon icon={faXTwitter} 
                      //style={{color: textColor ? textColor : null,}} 
                    />
                  </Button>
                :
                  <Button basic className={'site-content-button simple'}
                    style={{ color: textColor ? textColor : null, }}
                    as={buttonConfigState.as}
                    to={buttonConfigState.to}
                    href={buttonConfigState.href}
                    target={buttonConfigState.target}
                    rel={buttonConfigState.rel}
                    icon={buttonConfigState.icon}
                    labelPosition={buttonConfigState.labelPosition}
                    content={buttonConfigState.content}
                    // as={link && link.url !== null ? (isExternalLink ? 'a' : Link) : null}
                    // to={link && link.url !== null ? (isExternalLink ? null : link.url) : null}
                    // href={dOMID ? dOMID : isExternalLink ? link.url : null}
                    // target={isExternalLink ? '_blank' : null}
                    // rel={link && link.url ? 'noreferrer' : null}
                    // icon={icon && icon.iconName !== null ? icon.iconName : null}
                    // labelPosition={icon && icon.iconLabelPosition !== null ? icon.iconLabelPosition : null}
                    // content={linkText || (link && link.text)}
                  />
                }
              </>
            )
          default:
            return (
              <Button className={'site-content-button'}
                style={{ color: textColor ? textColor : null, }}
                as={buttonConfigState.as}
                to={buttonConfigState.to}
                href={buttonConfigState.href}
                target={buttonConfigState.target}
                rel={buttonConfigState.rel}
                icon={buttonConfigState.icon}
                labelPosition={buttonConfigState.labelPosition}
                content={buttonConfigState.content}
                // as={link && link.url !== null ? (isExternalLink ? 'a' : Link) : null}
                // to={link && link.url !== null ? (isExternalLink ? null : link.url) : null}
                // href={isExternalLink ? link.url : null}
                // target={isExternalLink ? '_blank' : null}
                // rel={link && link.url ? 'noreferrer' : null}
                // icon={icon && icon.iconName !== null ? icon.iconName : null}
                // labelPosition={icon && icon.iconLabelPosition !== null ? icon.iconLabelPosition : null}
                // content={linkText || (link && link.text)}
              />
            )
        }
      })()}
    </>
  )
}
